import { mapActions, mapGetters } from 'vuex';
import Swal from 'sweetalert2';
export default {
  name: 'ScheduleStatus',
  methods: {
    ...mapActions('schedule', ['submitSchedule']),
    onSubmit() {
      if (!this.projectScheduleLink) {
        this.noScheduleLink();
      } else {
        this.haveScheduleLink();
      }
    },
    noScheduleLink() {
      Swal.fire({
        icon: 'info',
        text: 'In order to submit your schedule, please ensure that you email the link to the schedule to your Account Manager, or use the Contact Us form to send it.',
        timer: 5000,
        showCloseButton: false,
        showCancelButton: false,
        showConfirmButton: false
      });
    },
    haveScheduleLink() {
      Swal.fire({
        text: 'If you are satisfied with your schedule, please click Confirm to send a note to your Account Manager informing them it is ready.',
        showCloseButton: false,
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonColor: '#EC008C',
        confirmButtonText: 'Confirm'
      }).then(result => {
        if (result.isConfirmed) {
          this.submitSchedule({
            projectID: this.project.id
          }).then(result => {
            this.project.schedule_status = result.data.schedule_status;
            window.location.href = '/projects/' + this.project.id + '/profile';
          }).catch(response => {
            const responseData = response.responseJSON;
            if (responseData && responseData.message) {
              Swal.fire({
                icon: 'error',
                text: responseData.message,
                title: 'Error'
              });
            }
          });
        }
      });
    }
  },
  computed: {
    ...mapGetters('schedule', ['project', 'loading', 'errors']),
    projectScheduleStatus() {
      let status = 'Pending';
      if (this.project && this.project.schedule_status) {
        status = this.project.schedule_status;
      }
      return status;
    },
    projectScheduleLink() {
      let link = null;
      if (this.project && this.project.schedule_link) {
        link = this.project.schedule_link;
      }
      return link;
    }
  }
};